var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiQuerySpaceTemplates } from './apis/api-query-space-templates.interface';
let SpaceTemplatesRepositoryImpl = class SpaceTemplatesRepositoryImpl {
    constructor(_apiQuerySpaceTemplates) {
        this._apiQuerySpaceTemplates = _apiQuerySpaceTemplates;
    }
    async querySpaceTemplates() {
        const resp = await this._apiQuerySpaceTemplates.querySpaceTemplates();
        const result = resp.map((item) => ({
            spaceTemplateId: item.field_template_id,
            spaceTemplateName: item.field_template_name,
        }));
        return result;
    }
};
SpaceTemplatesRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiQuerySpaceTemplates)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiQuerySpaceTemplates !== "undefined" && ApiQuerySpaceTemplates) === "function" ? _a : Object])
], SpaceTemplatesRepositoryImpl);
export { SpaceTemplatesRepositoryImpl };
